<template>
  <div v-if="visible" class="acct-switch">
    <div class="acct-switch-label">Comptes</div>

    <!-- Mon compte -->
    <div class="acct-row" :class="{ active: isActive(identityId) }" @click="choose(identityId)">
      <div class="acct-avatar">{{ initials(identityLabel.name) }}</div>
      <div class="acct-meta">
        <span class="acct-name">{{ identityLabel.name }} <span class="mine">(moi)</span></span>
        <span class="acct-email">{{ identityLabel.email }}</span>
      </div>
      <svg v-if="isActive(identityId)" class="check" viewBox="0 0 24 24" width="16" height="16"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5"/></svg>
    </div>

    <!-- Comptes partagés -->
    <div v-for="a in shared" :key="a.account_id" class="acct-row" :class="{ active: isActive(a.account_id) }" @click="choose(a.account_id)">
      <div class="acct-avatar shared">{{ initials(a.name) }}</div>
      <div class="acct-meta">
        <span class="acct-name">{{ a.name }}</span>
        <span class="acct-email">{{ roleLabel(a.role) }} · {{ scopeText(a) }}</span>
      </div>
      <svg v-if="isActive(a.account_id)" class="check" viewBox="0 0 24 24" width="16" height="16"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5"/></svg>
    </div>

  </div>
</template>

<script>
import {
  getIdentity, getActiveUser, ensureIdentity, isDelegated,
  listSharedAccounts, switchTo
} from '@/utils/accountSwitch';

export default {
  name: 'AccountSwitcher',
  data() {
    return { shared: [], switching: false };
  },
  computed: {
    // On n'affiche le sélecteur que s'il y a vraiment de quoi basculer :
    // au moins un compte partagé, ou une session actuellement déléguée.
    visible() { return this.shared.length > 0 || isDelegated(); },
    identityId() {
      const i = getIdentity() || getActiveUser();
      const d = i && (i.data || i);
      return d && d.id;
    },
    identityLabel() {
      const i = getIdentity() || getActiveUser();
      const d = (i && (i.data || i)) || {};
      return { name: d.name || 'Mon compte', email: d.email || '' };
    },
    activeId() {
      const u = getActiveUser(); const d = u && (u.data || u);
      return d && d.id;
    }
  },
  async mounted() {
    ensureIdentity();
    try { this.shared = await listSharedAccounts(); } catch (_) { this.shared = []; }
  },
  methods: {
    roleLabel(r) { return { admin: 'Administrateur', editor: 'Éditeur', viewer: 'Lecteur' }[r] || r; },
    // Portée affichée : le compte entier ou les agents partagés.
    scopeText(a) {
      if ((a.scope || 'account') !== 'chatbots') return 'Compte complet';
      const names = a.chatbot_names || [];
      return names.length === 1 ? `Agent : ${names[0]}` : `${names.length} agents`;
    },
    initials(name) {
      return (name || '?').split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();
    },
    isActive(id) { return id && this.activeId && String(id) === String(this.activeId); },
    async choose(id) {
      if (this.switching || this.isActive(id)) return;
      this.switching = true;
      try { await switchTo(id); } catch (e) { alert(e.message || 'Bascule impossible.'); this.switching = false; }
    }
  }
};
</script>

<style scoped>
.acct-switch { padding: 6px 4px 4px; border-top: 1px solid var(--border-color, #e1e5eb); margin-top: 4px; }
.acct-switch-label {
  font-size: 11px; text-transform: uppercase; letter-spacing: .04em;
  color: var(--text-muted, #9ca3af); padding: 6px 10px 4px;
}
.acct-row {
  display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 9px; cursor: pointer;
}
.acct-row:hover { background: var(--hover-bg, #f0f2f5); }
.acct-row.active { background: rgba(20,48,40,.06); }
.acct-avatar {
  width: 30px; height: 30px; border-radius: 8px; background: #143028; color: #DAFFD1;
  display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; flex-shrink: 0;
}
.acct-avatar.shared { background: #2563eb; color: #fff; }
.acct-meta { display: flex; flex-direction: column; min-width: 0; flex: 1; }
.acct-name { font-size: 13px; font-weight: 600; color: var(--text-color, #143028); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.acct-name .mine { color: var(--text-muted, #9ca3af); font-weight: 400; }
.acct-email { font-size: 11px; color: var(--text-muted, #6b7280); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.check { color: #16a34a; flex-shrink: 0; }
.acct-manage {
  display: flex; align-items: center; gap: 8px; padding: 9px 10px; margin-top: 4px; border-radius: 9px;
  cursor: pointer; color: #2563eb; font-size: 13px; font-weight: 500;
}
.acct-manage:hover { background: var(--hover-bg, #f0f2f5); }
</style>
